import {Heading} from "@cjdev-internal/visual-stack-x/Heading";
import {MDIcon} from "@cjdev-internal/visual-stack-x/MDIcon";
import {Text} from "@cjdev-internal/visual-stack-x/Text";
import {DO_NOT_CLOSE_WINDOW, CHECKING_FILE} from "../BulkUploadConstant";
import {Modal} from "@cjdev-internal/visual-stack-x/Modal";

const UploadNotification = () => {
    return (
        <Modal height="110px" minHeight="110px" width="465px">
            <div className='notificationModal' style={{textAlign: "center"}}>
                <MDIcon
                    size={24}
                    animation="beat"
                    icon="progress-upload"
                />
                <div className='heading'>
                    <Heading size={16} color="default">{CHECKING_FILE}</Heading>
                </div>
                <div className='description'>
                    <Text size={13} color="subdued">{DO_NOT_CLOSE_WINDOW}</Text>
                </div>
            </div>
        </Modal>
    )
}

export default UploadNotification;